export const FirestoreCollectionsPaths = {
  works: 'works',
  blogs: 'blogs',
  jobs: 'jobs',
  mail: 'mails',
  workWithId: (id) => `works/${id}`,
  blogWithId: (id) => `blogs/${id}`,
};


